"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
let ImportWarningComponent = class ImportWarningComponent {
    constructor() {
        this.showWarning = null;
    }
    ngOnInit() {
        if (!this.importResult || !this.importResult.nonDecodedSpecs)
            return;
        if (this.importResult.nonDecodedSpecs[this.selector]) {
            this.showWarning = this.importResult.nonDecodedSpecs[this.selector];
        }
    }
};
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", Object)
], ImportWarningComponent.prototype, "importResult", void 0);
__decorate([
    (0, core_1.Input)(),
    __metadata("design:type", String)
], ImportWarningComponent.prototype, "selector", void 0);
ImportWarningComponent = __decorate([
    (0, core_1.Component)({
        selector: 'import-warning',
        template: `
    <ng-container>
      <span
        *ngIf="showWarning"
        class="supporting-text warning"
      >
        <svg class="ab-icon"><use xlink:href="#error"></use></svg>
        <ng-container *ngIf="showWarning === 'NOT_AVAILABLE'"> Konnte bei VIN-Abfrage nicht identifiziert werden.</ng-container>
        <ng-container *ngIf="showWarning === 'OPTIONAL'"> Laut VIN-Abfrage ist dies optionale Ausstattung.</ng-container>
      </span>
    </ng-container>
  `,
    })
], ImportWarningComponent);
exports.default = ImportWarningComponent;
